import { useNavigate, useLocation } from 'react-router-dom'
import { Suspense, useEffect } from 'react'
import { homeRoutes } from 'src/routes'
import { useSelector } from 'react-redux'
import usePendingRedirect from 'src/hooks/usePendingRedirect'

const HomeLayout = () => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { goAfterLogin } = usePendingRedirect()
  const token = window.localStorage.getItem('token')
  const userDetails = useSelector((state) => state.userDetails)
  useEffect(() => {
    if (!token) {
      if (pathname !== '/' && pathname !== '/login' && pathname !== '/register') {
        navigate('/')
      }
    } else if (userDetails && userDetails.length > 0 && pathname !== '/add-profile') {
      goAfterLogin(userDetails[0]?.profileType, { consume: true, replace: true })
    }
  }, [token, userDetails, navigate, pathname, goAfterLogin])
  const cleanPathname =
    pathname.endsWith('/') && pathname !== '/' ? pathname.slice(0, -1) : pathname
  const currentRoute = homeRoutes.find((route) => route.path === cleanPathname) || homeRoutes[0]
  const Component = currentRoute.element

  return <Suspense fallback={null}>{Component ? <Component /> : null}</Suspense>
}

export default HomeLayout
